import React from 'react';
import ProgramsManager from '../Programs/ProgramsManager';
import { PROGRAM_TYPES } from '../../services/programsService';

const CapacityBuildingProgram = ({ userRole = 'client' }) => {
  if (userRole === 'client') {
    return null;
  }

  return <ProgramsManager userRole={userRole} programType={PROGRAM_TYPES.CAPACITY_BUILDING} />;
};

export default CapacityBuildingProgram;
